import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Route, Routes } from "react-router-dom";

import "./survey.css";
import { SurveyPage } from "./components/SurveyPage";

const queryClient = new QueryClient();

export function SurveyApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="wren-survey">
        <Routes>
          <Route path="pmf/:token" element={<SurveyPage />} />
        </Routes>
      </div>
    </QueryClientProvider>
  );
}
